import { Component, Input } from '@angular/core';
import { Categories } from 'src/app/models/types/Rule/Rule.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { RulesService } from 'src/app/services/api/rules.service';

@Component({
  selector: 'app-category-body',
  imports: [
    SharedModule
  ],
  templateUrl: './category-body.component.html',
  styleUrl: './category-body.component.scss'
})
export class CategoryBodyComponent {

  @Input('categories') categories!: Categories[];

  constructor(public readonly rulesService: RulesService){}


}
